import { Button, Modal } from "@legal-500/legal500-design-system";
import { useState, type ReactNode } from "react";
import styles from "./DbManager.module.css";

type ConfirmActionModalProps = {
  isOpen: boolean;
  title: string;
  body: ReactNode;
  confirmLabel: string;
  pendingLabel: string;
  errorLabel?: string;
  onClose: () => void;
  onConfirm: () => Promise<void>;
};

export function ConfirmActionModal({
  isOpen,
  title,
  body,
  confirmLabel,
  pendingLabel,
  errorLabel,
  onClose,
  onConfirm,
}: ConfirmActionModalProps) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleConfirm = async () => {
    setSubmitting(true);
    setError(null);
    try {
      await onConfirm();
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="small" blurBackground>
      <div className={styles.modalBody}>
        {error && <div className={styles.errorBanner}>{errorLabel ?? error}</div>}
        <div>{body}</div>
        <div className={styles.actions}>
          <Button variant="text" color="default" onClick={onClose} disabled={submitting}>
            Cancel
          </Button>
          <Button variant="contained" color="error" onClick={handleConfirm} disabled={submitting}>
            {submitting ? pendingLabel : confirmLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
